<template>
<div>
  <v-data-table
      loading-text="Loading... Please wait"
      class="users-table"
      :headers="invoicePaymentHeaders"
      :items="invoicePaymentItems"    
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip top>
          <template v-slot:activator="{}">
            <v-btn
                @click="showDeleteInvoicePaymentItemModal(item)"
                icon>
                <v-icon color="fontDefault">delete</v-icon>
            </v-btn>
          </template>
          <span>{{ languageData.labels.delete}}</span>
        </v-tooltip>
    </template>
  </v-data-table>
    <ModalInfo
        v-if="languageData.deleteInvoicePaymentItemModal"
        @doOperation="deleteInvoicePaymentItem"
        :isLoadingBtn="false"
        :headModal="languageData.deleteInvoicePaymentItemModal.head"
        :btnDisAgreeText="languageData.deleteInvoicePaymentItemModal.btnDisAgreeText"
        :btnAgreeText="languageData.deleteInvoicePaymentItemModal.btnAgreeText"
        :visDisAgreeBtn="true" 
        @clicked="hideDeleteInvoicePaymentItemModal"
        :show-modal="isShowDeleteInvoicePaymentItemModal"
        :text-modal="languageData.deleteInvoicePaymentItemModal.textInfo">
    </ModalInfo>
</div>
</template>

<script type="text/javascript">
import {mapActions} from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo.vue";

export default {
  name: "InvoicePaymentsTable",
  props: {
    invoicePaymentItems: Array,
    invoicePaymentHeaders: Array
  },
  components: {ModalInfo},
  data() {
    return {
        isShowDeleteInvoicePaymentItemModal: false,
        paymentItemIdToDelete: null,
    }
  },
  methods: {
    ...mapActions("deleteInvoicePaymentItem", ["deleteInvoicePaymentItemRequest"]),

    showDeleteInvoicePaymentItemModal(paymentItem) {
        this.paymentItemToDelete = paymentItem.id
        this.isShowDeleteInvoicePaymentItemModal = true;
    },
    hideDeleteInvoicePaymentItemModal() {
        this.isShowDeleteInvoicePaymentItemModal = false;
    },
    deleteInvoicePaymentItem() {
        this.deleteInvoicePaymentItemRequest({paymentId: this.paymentItemToDelete});
    }
  },
  computed: {

  },
  mounted() {
    eventBus.$on("deleteInvoicePaymentItemSuccess", () => {
      this.invoicePaymentItems.splice(this.invoicePaymentItems.findIndex(el => el.id === this.paymentItemIdToDelete), 1);
    });
  }
}
</script>